import { OvlAddComponent } from "../../../../../../_ovlclient/src/global/globals"
import { CompKpi } from "./kpicomponent"
import { CompKpiContainer } from "./kpicontainer"

export const KPI_Init = () => {
  OvlAddComponent("comp-kpi", CompKpi)
  OvlAddComponent("comp-kpicontainer", CompKpiContainer)
}
